import { useContext, useState } from "react";
import { callApi } from "../utils/ApiCallPostOnly";
// Context
import { AlertNotificationContext } from "../contexts/AlertNotificationContext";
// // Hooks
// import { useCheckAPI } from "../hooks/useCheckAPI";
// // State
// import { useReportDownload } from "../state/reportDownload";
// MUI imports
import Button from "@mui/material/Button";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

// Send docType - accepts PDF
export const DownloadDocumentBtn = ({ docType, path, docNo, disabled }) => {
  const { setAlertNotification } = useContext(AlertNotificationContext);
  const [downloading, setDownloading] = useState(false);

  const handleClick = async () => {
    setDownloading(true);
    const data = await callApi({
      path: path,
      command: docNo,
      data: "{}",
      download: true,
    });
    if (data.data.status === 200) {
      if (docType.toUpperCase() === "PDF")
        validatePDF(data.data.data.fileContent);
    } else {
      setAlertNotification({
        message: `Error: ${data.data.status}: ${data.data.statusText}`,
        severity: "warning",
      });
    }
    setDownloading(false);
  };

  const validatePDF = (base64String) => {
    if (base64String.startsWith("JVB")) {
      base64String = "data:application/pdf;base64," + base64String;
      downloadFile(base64String, `${docNo}.pdf`);
    } else if (base64String.startsWith("data:application/pdf;base64")) {
      downloadFile(base64String, `${docNo}.pdf`);
    } else {
      setAlertNotification({
        message: `Error: Not a valid Base64 PDF string`,
        severity: "warning",
      });
    }
  };

  const downloadFile = (file, fileName) => {
    const link = document.createElement("a");
    link.download = fileName;
    link.href = file;
    link.click();
  };

  return (
    <Button
      variant="outlined"
      color="info"
      endIcon={<FileDownloadIcon />}
      onClick={handleClick}
      disabled={disabled || downloading}
    >
      {downloading ? "Downloading.." : "Download"}
    </Button>
  );
};
